type LinkProps = {
  href: string;
  label: string;
};

export const HELP_LINKS_COLUMN_1: LinkProps[] = [
  {
    href: '/search/wedding-registry',
    label: 'Find a couple',
  },
  {
    href: '/order-status',
    label: 'Track order',
  },
  {
    href: '/order-status',
    label: 'Start a return',
  },
];

export const HELP_LINKS_COLUMN_2: LinkProps[] = [
  {
    href: '/returns',
    label: 'Return policy',
  },
  {
    href: '/contact-us',
    label: 'Contact us',
  },
  {
    href: '/faq',
    label: 'FAQs',
  },
];
